import { CancelButton, SaveButton } from '@core/components/Buttons';
import { FormDialogContent, SimpleDialog } from '@core/components/Dialog';
import { CompetenciaInput, DateInput } from '@core/components/Inputs';
import NossoNumero from '@core/components/NossoNumero';
import { SelectInput } from '@core/components/Select';
import { SimpleTable } from '@core/components/Table';
import { TableActionButton, TableActionContainer } from '@core/components/TableAction';
import { useReduxLoading } from '@core/hooks';
import { useApiUtils } from '@core/util/apiUtils';
import { Competencia, DataBR } from '@format';
import { useDebounce } from '@fuse/hooks';
import { Grid, Tooltip, makeStyles } from '@material-ui/core';
import PartnerBankIcon from 'app/assets/icon/partnerBankIcon';
import PixIcon from 'app/assets/icon/pixIcon';
import { SelectCategoria, SelectCliente } from 'app/components/Select';
import {
  ContaReceberErrosPartnerBankModal,
  ContaReceberVisualizacaoModal,
} from 'app/main/contareceber/components/modal';
import { contaReceberModais } from 'app/main/contareceber/components/modal/contaReceberModais';
import { ContaReceberContext, ContaReceberProvider } from 'app/main/contareceber/contaReceberContext';
import { ContaReceberRecorrenciaProvider } from 'app/main/contareceber/contaReceberRecorrenciaContext';
import { confirmarAlert, simpleAlert } from 'app/services/alerts';
import boletoApi from 'app/services/api/boletoApi';
import conciliacaoApi from 'app/services/api/conciliacaoApi';
import contaReceberApi from 'app/services/api/contaReceberApi';
import * as Actions from 'app/store/actions';
import { getCurrency } from 'app/utils/monetarioUtil';
import { FormikProvider, useFormik } from 'formik';
import React, { useContext, useEffect, useState } from 'react';
import { FaArrowAltCircleUp, FaEye } from 'react-icons/fa';
import { useDispatch } from 'react-redux';
import { ConciliacaoContext } from '../../ConciliacaoContext';
import { ConciliacaoModal } from '../../modal/ConciliacaoModal';

const contaReceberStyles = makeStyles({
  situacaoContainer: {
    display: 'inline-block',
  },
  badgeRetencao: {
    color: '#ffffff',
    paddingLeft: 6,
    paddingRight: 6,
    paddingTop: 2,
    paddingBottom: 2,
    fontSize: 12,
    fontWeight: 600,
    borderRadius: '0px !important',
    width: '20px',
    backgroundColor: '#3286a8',
    float: 'left',
  },
  badge: {
    color: '#ffffff',
    paddingLeft: 6,
    paddingRight: 6,
    paddingTop: 2,
    paddingBottom: 2,
    fontSize: 12,
    fontWeight: 600,
    borderRadius: '0px !important',
    width: '60px',
    textAlign: 'center',
  },
  badgeAberta: {
    backgroundColor: '#3286a8',
  },
  badgeBaixada: {
    backgroundColor: '#2dc44d',
  },
  badgeExcluida: {
    backgroundColor: '#b53838',
  },
  buttonEditDisabled: {
    cursor: 'default',
    color: 'white',
    borderRadius: '30%',
    padding: 4,
    border: 0,
    backgroundColor: 'rgb(157, 157, 157, 0.8)',
    '&:hover': {
      backgroundColor: 'rgb(157, 157, 157, 1)',
      boxShadow: 'none',
      borderColor: 'rgb(157, 157, 157, 0)',
    },
    '&:active': {
      boxShadow: 'none',
      backgroundColor: 'rgb(157, 157, 157, 0.9)',
      borderColor: 'rgb(157, 157, 157, 0)',
    },
    '&:focus': {
      boxShadow: '0 0 0 0.2rem rgb(157, 157, 157, 0.9)',
      borderColor: 'rgb(157, 157, 157, 0)',
    },
  },
});

const PesquisaContaReceberModal = ({ onSubmit }) => {
  const [modalPesquisa, setModalPesquisa] = useContext(ConciliacaoContext).modal;
  const [modal, setModal] = useContext(ContaReceberContext).modal;
  const [loading, setLoading] = useContext(ContaReceberContext).loading;
  const [totalElements, setTotalElements] = useContext(ContaReceberContext).totalElements;
  const [contasReceber, setContasReceber] = useContext(ContaReceberContext).contasReceber;
  const [, setContaReceberAtual] = useContext(ContaReceberContext).contaReceberAtual;
  const [somatorios, setSomatorios] = useContext(ContaReceberContext).somatorios;
  const [selecao, setSelecao] = useContext(ContaReceberContext).selecao;
  const [filtroAvancado, setFiltroAvancado] = useContext(ContaReceberContext).filtroAvancado;
  const [tipoSelecao, setTipoSelecao] = useContext(ContaReceberContext).tipoSelecao;
  const [page, setPage] = useContext(ContaReceberContext).page;
  const [search] = useContext(ContaReceberContext).search;
  const [size, setSize] = useContext(ContaReceberContext).size;
  const [sort, setSort] = useContext(ContaReceberContext).sort;
  const [extratoSelecionado, setExtratoSelecionado] = useContext(ConciliacaoContext).extratoSelecionado;
  const [contaReceberId, setContaReceberId] = useState('');

  const dispatch = useDispatch();
  const apiUtils = useApiUtils(dispatch, Actions);

  const showSuccess = (message) => {
    dispatch(Actions.showMessage({ message, variant: 'success' }));
  };

  const styles = contaReceberStyles();

  useReduxLoading(loading);

  useEffect(() => {
    const marcarSelecionadosLista = async () => {
      const selecionados = [];
      if (
        extratoSelecionado.contaReceberList &&
        extratoSelecionado.contaReceberList.filter((element) => !element.formulario).length > 0
      ) {
        extratoSelecionado.contaReceberList
          .filter((element) => !element.formulario)
          .map(async (conta) => {
            const res = await contaReceberApi.buscarPorId(conta.id);

            const nome = res.data.cliente.pessoa.nome;
            const valor = res.data.valorBruto;
            const valorPago = res.data.baixa?.valorPago;

            delete res.data.cliente;
            delete res.data.valor;

            selecionados.push({
              ...res.data,
              nomeCliente: nome,
              valor: valor,
              valorPago: valorPago,
            });
          });
      }

      setSelecao(selecionados);
    };

    marcarSelecionadosLista().catch(console.error);
    // Efeito de montagem: roda uma única vez. Incluir as dependências reexecutaria a carga
    // inicial a cada render (loop de chamadas à API).
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  const initialValues = {
    situacao: '',
    dataVencimentoRecebimento: undefined,
    dataLiquidacao: undefined,
    mesCompetencia: undefined,
    formaPagamento: undefined,
    fornecedor: undefined,
    categoria: undefined,
  };

  const formik = useFormik({
    initialValues: initialValues,
    onSubmit: onSubmit,
    validateOnChange: true,
  });

  const formikValues = formik?.values;
  useEffect(() => {
    setFiltroAvancado({ tipoConsultaConciliacao: 'NAO_CONCILIADOS', ...formikValues });
    fetchContasReceber({
      q: search,
      size,
      sort,
      filtroAvancado: { tipoConsultaConciliacao: 'NAO_CONCILIADOS', ...formikValues },
    });
    // A função é recriada a cada render; incluí-la reexecutaria a busca em loop.
    // O efeito depende apenas do gatilho listado.
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [formikValues]);

  const close = () => {
    formik.setValues({});
    setModalPesquisa('');
  };

  const initialPage = {
    page: 0,
    q: '',
    size: 15,
    sort: 'dataVencimento,DESC',
    filtroAvancado,
  };

  const fetchSomatorio = useDebounce(async (search = { ids: [], query: '', tipoSelecao: 'NENHUM', filtroAvancado }) => {
    if (search.selecao) {
      search.tipoSelecao = search.selecao;
      delete search.selecao;
    }
    const res = await contaReceberApi.somatorio(search);

    setSomatorios(res.data);
  });

  const fetchContasReceber = async (search = initialPage) => {
    setLoading(true);
    let searchAux = { ...search };
    try {
      if (!searchAux?.filtroAvancado) {
        searchAux.filtroAvancado = filtroAvancado;
      } else {
        searchAux.filtroAvancado.clienteId = search?.filtroAvancado?.cliente?.id;
      }
      delete searchAux.filtroAvancado.cliente;

      const response = await contaReceberApi.buscar(searchAux);

      if (searchAux.filtroAvancado.situacao === 'ABERTA_BAIXADA') {
        response.data.content.forEach((conta) => {
          if (conta?.situacao === 'EXCLUIDA') {
            response.data.content = response.data.content.filter((item) => item !== conta);
          }
        });
      } else {
        response.data.content.forEach((conta) => {
          if (conta?.situacao === 'ABERTA' && conta?.subJudice === true) {
            response.data.content = response.data.content.filter((item) => item !== conta);
          }
        });
      }

      setPage(response.data.number);
      setSize(response.data.size);
      setTotalElements(response.data.totalElements);

      setContasReceber(response.data.content);

      fetchSomatorio({ tipoSelecao: 'NENHUM', ids: [], ...search });
    } catch (err) {
      apiUtils.handleApiError(err);
    } finally {
      setLoading(false);
    }
  };

  const handleReenviarBoleto = (id) => {
    handleReenviarBoletoPartnerBank(id);
  };

  const handleReenviarBoletoPartnerBank = async (id) => {
    try {
      confirmarAlert({
        opcoes: {
          title: 'Tem certeza que deseja reenviar a cobrança?',
          confirmButtonText: 'Sim',
          cancelButtonText: 'Não',
        },
        confirmar: async () => {
          setLoading(true);

          await boletoApi.reenviarBoleto(id);

          setLoading(false);

          showSuccess('Cobrança reenviada ao Partner Bank com sucesso.');

          fetchContasReceber({ page, q: search, size, filtroAvancado });
        },
      });
    } catch (err) {
      setLoading(false);

      apiUtils.handleApiError(err);
    }
  };

  const handleVisualizarErrosPartnerBank = (id) => {
    setContaReceberId(id);

    setModal(contaReceberModais.errosPartnerBank);
  };

  const fetchContaReceber = async (id) => {
    setLoading(true);
    try {
      const response = await contaReceberApi.buscarPorId(id);

      const contaReceber = response?.data;

      if (
        contaReceber?.baixa?.juros ||
        contaReceber?.baixa?.multa ||
        contaReceber?.baixa?.desconto ||
        contaReceber?.baixa?.correcaoMonetaria
      ) {
        contaReceber.baixa.acrescimoDesconto = true;
      }

      let historico = [];
      try {
        const responseHistorico = await contaReceberApi.buscarHistorico(id);
        historico = responseHistorico?.data || [];
      } catch (error) {
        historico = [];
      }

      setContaReceberAtual({ ...contaReceber, historico });
    } catch (err) {
      console.error(err);
      useApiUtils.handleApiError(err);
    } finally {
      setLoading(false);
    }
  };

  const columns = [
    {
      name: 'cliente.pessoa.nome',
      title: 'Cliente',
      align: 'left',
      getCellValue: (contaReceber) => contaReceber.nomeCliente,
      sortingEnabled: true,
    },

    {
      name: ' ',
      title: '',
      align: 'left',
      hideTooltip: true, // Implementar no tooltip código de transação do Pix
      width: 40,
      sortingEnabled: false,
      getCellValue: (data) => (
        <>
          <div>
            {data?.tipoCobranca === 'PIX' && <PixIcon size="15" color="#5890aa" />}
            {data?.tipoCobranca === 'PARTNER_BANK' && <PartnerBankIcon size="20" />}
          </div>
        </>
      ),
    },

    {
      name: 'mesCompetencia',
      title: 'Competência',
      align: 'center',
      getCellValue: (data) => Competencia(data.mesCompetencia),
      hideTooltip: true,
      sortingEnabled: true,
    },
    {
      name: 'receitaCobranca.nossoNumero',
      title: 'Nosso número',
      align: 'center',
      getCellValue: (contaReceber) => {
        return (
          <NossoNumero
            id={contaReceber.id}
            value={contaReceber?.nossoNumero || contaReceber?.nossoNumeroAntigo}
            situacao={getSituacaoRemessa(contaReceber)}
            type="CONTA_RECEBER"
            hasError={contaReceber?.situacaoRemessa === 'REJEITADA'}
            showIconError={
              contaReceber?.situacaoRemessa === 'REJEITADA' && contaReceber?.tipoCobranca === 'PARTNER_BANK'
            }
            onClickError={handleVisualizarErrosPartnerBank}
            tooltipError="Visualizar erros de registro"
            reenviar={contaReceber?.situacaoRemessa === 'PENDENTE' && contaReceber?.tipoCobranca === 'PARTNER_BANK'}
            onClickReenviar={handleReenviarBoleto}
            tooltipReenviar="Reenviar cobrança ao Partner Bank"
            reenviarDisabled={
              contaReceber?.situacaoRemessa === 'REENVIADA' && contaReceber?.tipoCobranca === 'PARTNER_BANK'
            }
            tooltipReenviarDisabled="A cobrança já foi enviada ao Partner Bank"
          />
        );
      },
      hideTooltip: true,
      sortingEnabled: true,
    },
    {
      name: 'dataVencimento',
      title: 'Vencimento',
      align: 'center',
      getCellValue: (data) => data.dataVencimento && DataBR(data.dataVencimento),
      hideTooltip: true,
      sortingEnabled: true,
    },
    {
      name: 'valorBruto',
      title: 'Valor (R$)',
      align: 'right',
      getTooltip: (contaReceber) => getCurrency(contaReceber?.valor),
      getCellValue: (contaReceber) => {
        return getValorContaReceber(contaReceber);
      },
      sortingEnabled: true,
    },
    {
      name: 'valorRecebido',
      title: 'Valor recebido (R$)',
      align: 'right',
      getCellValue: (contaReceber) => {
        return contaReceber?.valorPago !== null && contaReceber?.valorPago !== undefined
          ? getCurrency(contaReceber?.valorPago)
          : undefined;
      },
      sortingEnabled: true,
    },

    {
      name: '',
      title: '',
      sortingEnabled: false,
      align: 'left',
      width: 125,
      getCellValue: (contaPagar) => {
        return (
          <TableActionContainer style={{ display: 'block' }}>
            <TableActionButton
              title="Visualizar"
              icon={<FaEye size={10} />}
              onClick={() => handleOpenVisualizarModal(contaPagar)}
            />
          </TableActionContainer>
        );
      },
    },
  ];

  const getSomatorioSelecao = () => {
    let total = 0;
    if (tipoSelecao === 'TODOS_FILTRO') {
      total = somatorios?.somatorioFiltro;
    } else if (selecao) {
      selecao.forEach((receita) => {
        if (receita.situacao === 'BAIXADA') {
          total += receita.valorPago;
        } else {
          total += receita.valor;
        }
      });
    }
    return total;
  };

  const getValorDiferenca = () => {
    const somatorioSelecionados = getSomatorioSelecao() || 0;
    return Math.abs(extratoSelecionado?.valor) - somatorioSelecionados;
  };

  const getIconRetencao = () => {
    return (
      <Tooltip title="Cobrança possui retenção de impostos">
        <div className={`${styles.badgeRetencao}`}>R</div>
      </Tooltip>
    );
  };

  const getValorContaReceber = (contaReceber) => {
    return (
      <div>
        {contaReceber?.possuiRetencao && getIconRetencao()}
        <div>{getCurrency(contaReceber?.valor)}</div>
      </div>
    );
  };

  const getSituacaoRemessa = (contaReceber) => {
    const excluido = contaReceber.situacao === 'EXCLUIDA';
    const baixado = contaReceber.situacao === 'BAIXADA';

    if (
      contaReceber.situacaoRemessa === 'NAO_TRATADA_BANCO' ||
      ((contaReceber.situacaoRemessa === 'PENDENTE' || contaReceber.situacaoRemessa === 'GERADA') &&
        (excluido || baixado))
    ) {
      return 'NAO_TRATADA_BANCO';
    }

    return contaReceber.situacaoRemessa;
  };

  const handleOpenVisualizarModal = async (contaReceber) => {
    await fetchContaReceber(contaReceber?.id);

    setModal(contaReceberModais.visualizarContaReceber);
  };

  const verificarBaixa = (baixas) => {
    const baixasFiltradas = baixas?.filter((baixa) => {
      return baixa?.valorPago === extratoSelecionado?.valor;
    });
    return baixasFiltradas;
  };

  const isBaixaDivergente = (conta) => {
    if (conta.situacao === 'PARCIAL') {
      const baixas = verificarBaixa(conta?.baixas);
      if (baixas?.length === 0) {
        return true;
      } else {
        return false;
      }
    }
    return false;
  };

  const getBaixa = (conta) => {
    if (conta.situacao === 'PARCIAL') {
      const baixas = verificarBaixa(conta?.baixas);
      if (baixas.length > 0) {
        return [
          {
            dataRecebimento: baixas[0]?.dataRecebimento,
            dataLiquidacao: baixas[0]?.dataLiquidacao,
            valorPago: baixas[0]?.valorPago,
          },
        ];
      }
    }
    if (conta.situacao === 'BAIXADA' && conta?.baixas?.length > 0) {
      let ultimaDataRecebimento =
        conta.baixas?.map((baixa) => baixa.dataRecebimento).sort((a, b) => new Date(b) - new Date(a))[0] || null;

      let ultimaDataLiquidacao =
        conta.baixas?.map((baixa) => baixa.dataLiquidacao).sort((a, b) => new Date(b) - new Date(a))[0] || null;

      let somatorioValoresPagos =
        conta.baixas?.map((baixa) => baixa.valorPago).reduce((acc, valorPago) => acc + (valorPago || 0), 0) || null;

      return [
        {
          dataRecebimento: ultimaDataRecebimento,
          dataLiquidacao: ultimaDataLiquidacao,
          valorPago: somatorioValoresPagos,
        },
      ];
    }
  };

  const getValor = (conta) => {
    if (conta.situacao === 'PARCIAL') {
      const baixas = verificarBaixa(conta?.baixas);
      if (baixas.length > 0) {
        return baixas[0].valorPago;
      }
    }
    if (conta.situacao === 'BAIXADA' && conta?.baixas?.length > 0) {
      return conta?.baixas?.map((baixa) => baixa.valorPago).reduce((acc, valorPago) => acc + (valorPago || 0), 0);
    }

    return conta?.valor;
  };

  const montaEstruturaDoLancamento = (conta) => {
    return {
      id: conta.id,
      cliente: { pessoa: { nome: conta.nomeCliente } },
      baixas: getBaixa(conta),
      valor: getValor(conta),
      categorias: conta?.categorias,
      formulario: false,
      situacao: conta.situacao,
      contaDivergente:
        conta.contaBancariaId && conta.contaBancariaId !== extratoSelecionado.contaBancariaId ? true : false,
      baixaDivergente: isBaixaDivergente(conta),
      receitaCobranca: {
        situacaoRemessa: conta.situacaoRemessa,
        tipoCobranca: conta.tipoCobranca,
      },
    };
  };

  const possuiReceitaBaixadaSemVinculoComConta = (receitas) => {
    return receitas.some((receita) => receita.contaDivergente === true);
  };

  const possuiReceitaComBaixaDivergente = (receitas) => {
    return receitas.some((receita) => receita.baixaDivergente === true);
  };

  const selecionaReceitasSemDivergencias = (receitas) => {
    const receitasValidas = receitas.filter((receita) => receita.contaDivergente === false);

    if (receitasValidas.length > 0) {
      setExtratoSelecionado({
        ...extratoSelecionado,
        contaReceberList: receitasValidas,
      });
    }
    formik.handleSubmit();
  };

  const adicionarReceitasNoExtrato = (receitas) => {
    if (possuiReceitaBaixadaSemVinculoComConta(receitas)) {
      simpleAlert({
        opcoes: {
          title: 'Não é possível selecionar a conta, pois ela foi baixada com uma conta bancária diferente do extrato.',
        },
      });
    } else if (possuiReceitaComBaixaDivergente(receitas)) {
      simpleAlert({
        opcoes: {
          title: 'Não é possível selecionar a conta, pois o valor diverge do valor registrado no extrato.',
        },
      });
    } else {
      selecionaReceitasSemDivergencias(receitas);
    }
  };

  const buscaContasFiltroTodos = () => {
    let receitas = [];
    conciliacaoApi.buscarContaReceberFiltroTodos({ ...formik?.values, tipoSelecao: 'TODOS_FILTRO' }).then((contas) => {
      if (contas.data.length > 0) {
        let contemContaReceberParcial = contas?.data?.some((conta) => conta?.situacao === 'PARCIAL');
        if (!contemContaReceberParcial) {
          contas.data.forEach((conta) => {
            receitas.push(montaEstruturaDoLancamento(conta));
          });
        } else {
          simpleAlert({
            opcoes: {
              title: 'Não é possível selecionar mais de uma conta quando uma delas estiver com baixa parcial.',
            },
          });
        }
      }

      adicionarReceitasNoExtrato(receitas);
    });
  };

  const buscaContasSelecionadas = () => {
    let receitas = [];

    let contemContaReceberParcial = selecao?.some((conta) => conta?.situacao === 'PARCIAL' && selecao?.length > 1);
    if (!contemContaReceberParcial) {
      selecao.forEach((conta) => {
        receitas.push(montaEstruturaDoLancamento(conta));
      });
      adicionarReceitasNoExtrato(receitas);
    } else {
      simpleAlert({
        opcoes: {
          title: 'Não é possível selecionar mais de uma conta quando uma delas estiver com baixa parcial.',
        },
      });
    }
  };

  const vincularContasComExtrato = async () => {
    setLoading(true);
    if (tipoSelecao === 'TODOS_FILTRO') {
      buscaContasFiltroTodos();
    } else if (selecao?.length > 0) {
      buscaContasSelecionadas();
    }
    setLoading(false);
  };

  const footerTable = (
    <div>
      <div style={{ padding: '12px 0 0 24px', fontWeight: 'bold' }}>
        Valor total do extrato (R$):
        {new Intl.NumberFormat('pt-BR', { style: 'currency', currency: 'BRL' })
          .format(Math.abs(extratoSelecionado?.valor))
          .replace('R$', '')}
      </div>
      <div style={{ padding: '12px 0 0 24px', fontWeight: 'bold' }}>
        Valor das receitas selecionadas (R$):
        {new Intl.NumberFormat('pt-BR', { style: 'currency', currency: 'BRL' })
          .format(getSomatorioSelecao())
          .replace('R$', '')}
      </div>
      <div style={{ display: 'flex', flexDirection: 'row', alignItems: 'end' }}>
        <div style={{ padding: '12px 0 0 24px', fontWeight: 'bold' }}>Valor da diferença (R$):</div>
        <div style={{ color: 'red', fontWeight: 'bold', marginLeft: 2 }}>
          {new Intl.NumberFormat('pt-BR', { style: 'currency', currency: 'BRL' })
            .format(getValorDiferenca())
            .replace('R$', '')}
        </div>
      </div>
    </div>
  );

  const hiddenColumnNames = [];

  // RNE-813
  if (
    filtroAvancado.situacao !== 'BAIXADA' &&
    filtroAvancado.situacao !== 'ABERTA_BAIXADA' &&
    filtroAvancado.situacao !== 'PARCIAL'
  ) {
    hiddenColumnNames.push('valorRecebido');
  }

  return (
    <>
      {modalPesquisa === ConciliacaoModal.pesquisaContaReceber ? (
        <ContaReceberRecorrenciaProvider>
          <ContaReceberProvider>
            <SimpleDialog
              fullScreen
              open={modalPesquisa === ConciliacaoModal.pesquisaContaReceber}
              onClose={close}
              innerScroll
            >
              <FormikProvider value={formik}>
                <FormDialogContent
                  onSubmit={async (e) => {
                    vincularContasComExtrato();
                  }}
                  fullScreen
                  header={{
                    title: 'Buscar contas a receber',
                    icon: <FaArrowAltCircleUp />,
                    toolbar: (
                      <>
                        <CancelButton title="cancelar" type="button" onClick={close}>
                          Cancelar
                        </CancelButton>
                        <SaveButton color="buttonSave" type="submit" styles={undefined} variant={'contained'}>
                          Selecionar
                        </SaveButton>
                      </>
                    ),
                  }}
                  content={
                    <>
                      <Grid>
                        <Grid container style={{ padding: 16 }} spacing={3}>
                          <Grid item xs={12} sm={12} md={3} lg={3} xl={3}>
                            <SelectInput
                              id="situacao"
                              label="Situação"
                              onChange={formik.handleChange}
                              value={formik.values?.situacao}
                              options={[
                                { id: 'ABERTA', title: 'Aberta' },
                                { id: 'BAIXADA', title: 'Baixada' },
                                { id: 'ABERTA_BAIXADA', title: 'Aberta e baixada' },
                                { id: 'PARCIAL', title: 'Parcial' },
                              ]}
                            />
                          </Grid>
                          <Grid item xs={12} sm={12} md={3} lg={3} xl={3}>
                            <DateInput
                              fullWidth
                              id="dataVencimentoRecebimento"
                              label="Data do vencimento/recebimento"
                              value={formik.values?.dataVencimentoRecebimento}
                              onChange={formik.handleChange}
                              onBlur={formik.handleBlur}
                            />
                          </Grid>
                          <Grid item xs={12} sm={12} md={3} lg={3} xl={3}>
                            <DateInput
                              fullWidth
                              id="dataLiquidacao"
                              label="Data da liquidação"
                              value={formik.values?.dataLiquidacao}
                              onChange={formik.handleChange}
                              onBlur={formik.handleBlur}
                              error={!!formik.errors.dataLiquidacao}
                              helperText={formik.errors.dataLiquidacao}
                            />
                          </Grid>
                          <Grid item xs={12} sm={12} md={3} lg={3} xl={3}>
                            <CompetenciaInput
                              fullWidth
                              onBlur={formik.handleBlur}
                              id="mesCompetencia"
                              label="Mês competência"
                              value={formik.values?.mesCompetencia}
                              onChange={formik.handleChange}
                              format="MM/YYYY"
                            />
                          </Grid>

                          <Grid item xs={12} sm={12} md={6} lg={6} xl={6}>
                            <SelectCliente
                              id="cliente"
                              label="Cliente"
                              onChange={formik.handleChange}
                              value={formik.values?.cliente}
                            />
                          </Grid>

                          <Grid item xs={12} sm={12} md={6} lg={6} xl={6}>
                            <SelectCategoria
                              id="categoria"
                              label="Categoria"
                              value={formik.values?.categoria}
                              onChange={formik.handleChange}
                              maxLength={100}
                              natureza="RECEITA"
                            />
                          </Grid>
                        </Grid>
                      </Grid>
                      <Grid container>
                        <SimpleTable
                          fetchOnCreate
                          defaultSorting={[{ columnName: 'dataVencimento', direction: 'desc' }]}
                          columns={columns}
                          rows={contasReceber}
                          selection={selecao}
                          loading={loading}
                          totalCount={totalElements}
                          searchBy={search}
                          fetchData={fetchContasReceber}
                          onRowClick={handleOpenVisualizarModal}
                          onCurrentPageChange={(params) => {
                            setPage(params);
                          }}
                          onPageSizeChange={(params) => {
                            setSize(params);
                          }}
                          selectionType={tipoSelecao}
                          onSelectionTypeChange={(params) => {
                            setTipoSelecao(params);
                          }}
                          onSortingChange={setSort}
                          onSelectionChange={(params) => {
                            setSelecao(params);
                          }}
                          footerTable={footerTable}
                          params={filtroAvancado}
                          hiddenColumnNames={hiddenColumnNames}
                        />
                      </Grid>
                    </>
                  }
                />
              </FormikProvider>
            </SimpleDialog>
            {modal === contaReceberModais.errosPartnerBank && (
              <ContaReceberErrosPartnerBankModal
                openModal={modal === contaReceberModais.errosPartnerBank}
                onCloseModal={() => setModal('')}
                contaReceberConciliacaoId={contaReceberId}
              />
            )}
            <ContaReceberVisualizacaoModal />
          </ContaReceberProvider>
        </ContaReceberRecorrenciaProvider>
      ) : null}
    </>
  );
};

export default PesquisaContaReceberModal;
